import { render } from "./EstadoPagoList.vue?vue&type=template&id=72a1b944&scoped=true"
import script from "./EstadoPagoList.vue?vue&type=script&lang=js"
export * from "./EstadoPagoList.vue?vue&type=script&lang=js"

import "./EstadoPagoList.vue?vue&type=style&index=0&id=72a1b944&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a1b944"]])

export default __exports__